/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class SignOut extends PageStringSection {
    button_signIn_label: string = "Labels.lbl_SignIn";
    heading_signOut: string = "Labels.lbl_SignOut";
    text_signOut: string = "Messages.msg_AccountSignedOut";
}
